var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.086,
    height: 16.244,
    viewBox: "0 0 22.086 16.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0.3px;",
    d: "M21.392,68.315a1.085,1.085,0,0,0-1.535,0L6.852,81.321l-5-5A1.086,1.086,0,0,0,.317,77.857l5.767,5.767a1.086,1.086,0,0,0,1.535,0L21.392,69.851A1.086,1.086,0,0,0,21.392,68.315Z",
    transform: "translate(0.151 -67.847)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick2);
export default __webpack_public_path__ + "static/media/tick2.bd4ccfd82ade7bf08fbb25d0e5872229.svg";
export { ForwardRef as ReactComponent };